import React from "react";
import CustomImageComponent from "../../components/CustomImageComponent";

const NotFoundSec = (props) => {
  const { title, desc, cssstyle, img = "/assets/img/404.svg" } = props
  return (
    <>
      <section className={`not-found-section ${cssstyle}`}>
        <div className="container">
          <h2 className="title">{title}</h2>
          <h5 className="sub-title">{desc}</h5>
          <CustomImageComponent src={img} alt={"404 Not Found"} className={"img-fluid "} />
        </div>
      </section>
    </>
  );
};

export default NotFoundSec;
